export default "__VITE_ASSET__D_R4b2Ka__"